<div class="ds-form-field" [class.has-error]="hasError">
  <div class="ds-error-box" *ngIf="hasError"></div>

  <div
    *ngIf="errorMessage && hasError"
    [id]="id + '-error'"
    class="ds-error-text"
    role="alert"
  >
    {{ errorMessage }}
  </div>

  <label [for]="id" class="ds-field-label">
    {{ label }}
    <span *ngIf="required" class="ds-required-asterisk" aria-hidden="true"
      >*</span
    >
  </label>

  <div
    class="ds-input-wrapper"
    [class.has-toggle]="showPasswordToggle && type === 'password'"
  >
    <input
      #input
      [type]="inputType"
      [step]="type === 'number' ? 'any' : ''"
      [id]="id"
      [placeholder]="placeholder"
      [autocomplete]="autocomplete"
      [value]="value"
      [required]="required"
      [disabled]="disabled"
      [attr.aria-required]="required ? 'true' : null"
      [attr.aria-invalid]="hasError ? 'true' : null"
      [attr.aria-describedby]="errorMessage && hasError ? id + '-error' : null"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      class="ds-form-input"
      [class.ds-form-input--date]="type === 'date'"
    />

    <button
      *ngIf="showPasswordToggle && type === 'password'"
      type="button"
      class="ds-password-toggle"
      (click)="togglePasswordVisibility()"
      [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
    >
      <i
        class="bi"
        [class.bi-eye-slash]="hidePassword"
        [class.bi-eye]="!hidePassword"
      ></i>
    </button>
  </div>

  <ng-content></ng-content>
</div>
